// src/components/DeepLinkBridge.jsx
//
// Tiny mount point for the useDeepLinks hook. Must live INSIDE the React
// Router (so useNavigate works). Renders nothing.
//
// Web builds: no-op.
// Capacitor iOS / Android: routes Universal Link / App Link taps into
// React Router so push notification taps and email links land on the
// correct screen instead of a stale WebView.

import useDeepLinks from '@/hooks/useDeepLinks';

export default function DeepLinkBridge() {
  useDeepLinks();
  return null;
}
